import _ from "lodash";

import createScheduledRules from "../lists/createScheduledRules";
import dateTimeRange from "../lists/dateTimeRange";
import rulesFromTimeStamps from "../lists/rulesFromTimeStamps";
import timeStampsFromRange from "../lists/timeStampsFromRange";
import dayOfWeekRuleCreator from "../lists/dayOfWeekRuleCreator";
import createDatesOfMonthRules from "../lists/createDatesOfMonthRules";
import weeklyRuleCreator from "../lists/weeklyRuleCreator";
import repeatWeeklyRule from "../lists/repeatWeeklyRule";
import { GEOFENCE_SCHEDULE_TYPES } from "../../constants";

export default (form) => {
  /**
   * @param {Object} form (see destructured args)
   * @return {Object.<{scheduleName: String, rules: Array[]<Object>}>} scheduled rules
   */

  let groupRule = [];
  const { scheduleName, scheduleType, startTime, startDate, endTime, endDate } = form;
  const timeRange = dateTimeRange(startDate, startTime, endDate, endTime);
  const timeStampsArray = timeStampsFromRange(timeRange.startDate, timeRange.endDate);
  const selectedWeekDays = _.uniq((form.selectedWeekDays || []).map((day) => day.toLowerCase()));
  const selectedMonths = _.uniq((form.selectedMonths || []).map((month) => month.toLowerCase()));

  if (scheduleType === GEOFENCE_SCHEDULE_TYPES.doesNotRepeat) {
    const rules = rulesFromTimeStamps(timeStampsArray);
    const schedule = createScheduledRules(rules, scheduleName);
    return schedule;
  }

  if (scheduleType === GEOFENCE_SCHEDULE_TYPES.dayOfWeek) {
    const dayOfWeekRules = dayOfWeekRuleCreator({
      daysOfWeekSpan: timeStampsArray,
      week_days: selectedWeekDays,
      monthSelection: selectedMonths,
      scheduleName,
    });

    groupRule = dayOfWeekRules;
  }

  if (scheduleType === GEOFENCE_SCHEDULE_TYPES.datesOfMonth) {
    const rules = rulesFromTimeStamps(timeStampsArray);

    const monthFromDropdownList = form.selectedMonthDropdown.toLowerCase();

    const dateOfMonthRules = createDatesOfMonthRules(
      { rules, scheduleName },
      form.datesOfMonth,
      monthFromDropdownList,
    );
    groupRule = dateOfMonthRules;
  }

  if (scheduleType === GEOFENCE_SCHEDULE_TYPES.weekly) {
    const weeklyRule = weeklyRuleCreator({
      daySpanList: timeStampsArray,
      scheduleName: form.scheduleName,
    });
    const repeatedWeeklyRules = repeatWeeklyRule(weeklyRule, selectedMonths);

    groupRule = repeatedWeeklyRules;
  }
  return groupRule;
};
